<ion-content>
  <div class="header-container">
    <ion-item lines="none" class="safe-area-top-pad">
      <ion-button (click)="close()" fill="clear" slot="end">
        <ion-icon slot="icon-only" name="close" color="light"></ion-icon>
      </ion-button>
    </ion-item>
  </div>
  <div class="container">
    <div class="scanner-area-container">
      <div class="relative">
        <p>{{ "modals.barcode_scanner_modal.message" | translate }}</p>
      </div>
      <div class="square surround-cover">
        <div class="scanner-area-outer surround-cover">
          <div class="scanner-area-inner"></div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
